import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let calendar_date_user = new BaseTableModule('/ws/calendar_date_user/');

const state = {
    ...calendar_date_user.state,
    columns: [
        {text: 'User', value: 'human_user', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Previous year total, Σ=', value: 'holiday_prev_total', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Previous year spend, Σ=', value: 'holiday_prev_spend', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Total in current year, Σ=', value: 'holiday_current_total', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Spend in current year, Σ=', value: 'holiday_current_spend', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Planing but not spend in current year, Σ=', value: 'holiday_current_plan', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Available in current year, Σ=', value: 'holiday_current_available', sortable: false, filterable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['-id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
};
const getters = {
    ...calendar_date_user.getters,
    getColumns(state) {
        // console.log('getColumns', state.columns, state.aggregateItemList)
        let resultColumns = []
        for (const item of state.columns) {
            if (item.value in state.aggregateItemList)
                item.text = item.text.replace(/Σ=.*/, 'Σ=' + state.aggregateItemList[item.value])
            resultColumns.push(item)
        }
        return resultColumns
    },
};
const actions = {
    ...calendar_date_user.actions,
};
const mutations = {
    ...calendar_date_user.mutations,
};

export default {
    modules: {
        CalendarDateUserStatisticBegin: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}